import {ProductSearchSuggestion} from "@app/core/product/domain/dtos/product-search-suggestion";

export class ProductSearchSuggestionMapper {
    static deserialize(param: any): ProductSearchSuggestion {
        return {
            code: param.code,
            name: param.name,
        } as ProductSearchSuggestion

    }
}
